// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__1SJOB","active":"Item_active__1eWbA","head":"Item_head__dv4jr","body":"Item_body__25CCo","button":"Item_button__2-owL"};